import { MARQUEE_ITEMS } from "@/lib/site";

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-forest/10 bg-sage py-5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {MARQUEE_ITEMS.map((item) => (
              <span key={`${half}-${item}`} className="flex items-center whitespace-nowrap">
                <span className="px-6 font-display text-2xl italic text-forest sm:text-3xl">{item}</span>
                <span className="h-2 w-2 rounded-full bg-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
